import React, { useState } from 'react';
import { FiMail, FiMessageCircle, FiPhone, FiHelpCircle, FiSend, FiCheckCircle } from 'react-icons/fi';

const Support = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

    const supportEmail = 'support@ringez.com';
    const axios = require('axios'); // Ensure axios is imported or available

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await axios.post(`${API_URL}/support/contact`, {
                name,
                email,
                message
            });

            if (res.data.success) {
                setSent(true);
                setName('');
                setEmail('');
                setMessage('');
                setTimeout(() => setSent(false), 5000);
            }
        } catch (error) {
            console.error('Support email failed:', error);
            alert('Failed to send message. Please try again or email us directly.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="animate-fade">
            <h1>Help & Support</h1>

            <div className="card" style={{ marginBottom: '2rem' }}>
                <div style={{ textAlign: 'center', padding: '2rem 1rem' }}>
                    <div style={{
                        width: '80px',
                        height: '80px',
                        background: 'linear-gradient(135deg, #6366f1, #a855f7)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1.5rem'
                    }}>
                        <FiHelpCircle size={40} color="white" />
                    </div>
                    <h2 style={{ marginBottom: '0.5rem' }}>Need Help?</h2>
                    <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
                        We're here to help you with any questions or issues.
                    </p>
                </div>

                {/* Direct Email Contact */}
                <div style={{
                    background: 'rgba(99, 102, 241, 0.1)',
                    border: '1px solid rgba(99, 102, 241, 0.2)',
                    borderRadius: '1rem',
                    padding: '1.5rem',
                    marginBottom: '2rem'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            background: 'var(--primary)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FiMail size={24} color="white" />
                        </div>
                        <div>
                            <p style={{ fontWeight: 600, color: 'var(--text-main)', marginBottom: '0.25rem' }}>Email Support</p>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>Get a response within 24 hours</p>
                        </div>
                    </div>
                    <a
                        href={`mailto:${supportEmail}`}
                        style={{
                            display: 'block',
                            background: 'var(--primary)',
                            color: 'white',
                            textAlign: 'center',
                            padding: '0.875rem',
                            borderRadius: '0.75rem',
                            fontWeight: 600,
                            textDecoration: 'none',
                            transition: 'all 0.2s'
                        }}
                    >
                        <FiMail style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                        {supportEmail}
                    </a>
                </div>

                {/* Contact Form */}
                <div>
                    <h3 style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <FiMessageCircle /> Send a Message
                    </h3>

                    {sent ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '2rem',
                            background: 'rgba(34, 197, 94, 0.1)',
                            borderRadius: '1rem',
                            border: '1px solid rgba(34, 197, 94, 0.2)'
                        }}>
                            <FiCheckCircle size={48} color="#22c55e" style={{ marginBottom: '1rem' }} />
                            <p style={{ color: '#22c55e', fontWeight: 600 }}>Message Sent!</p>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>We'll get back to you at {email} shortly.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: '1rem' }}>
                                <input
                                    type="text"
                                    placeholder="Your Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                    style={{ marginBottom: 0 }}
                                />
                            </div>
                            <div style={{ marginBottom: '1rem' }}>
                                <input
                                    type="email"
                                    placeholder="Your Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    style={{ marginBottom: 0 }}
                                />
                            </div>
                            <div style={{ marginBottom: '1.5rem' }}>
                                <textarea
                                    placeholder="Describe your issue or question..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                    rows={4}
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 1rem',
                                        background: '#0f172a',
                                        border: '1px solid var(--border)',
                                        borderRadius: '0.5rem',
                                        color: 'var(--text-main)',
                                        resize: 'vertical',
                                        fontFamily: 'inherit'
                                    }}
                                />
                            </div>
                            <button
                                type="submit"
                                className="primary"
                                disabled={loading}
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    opacity: loading ? 0.7 : 1
                                }}
                            >
                                {loading ? 'Sending...' : <><FiSend /> Send Message</>}
                            </button>
                        </form>
                    )}
                </div>
            </div>

            {/* FAQ/Quick Tips */}
            <div className="card">
                <h3 style={{ marginBottom: '1.5rem' }}>Frequently Asked Questions</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {[
                        { q: 'How do I add money?', a: 'Go to Wallet tab and use PayPal (USD) or UPI (INR) to top up your balance.' },
                        { q: 'What format for phone numbers?', a: 'Use international format: +1 (USA), +91 (India), +44 (UK) followed by number.' },
                        { q: 'Why is my call failing?', a: 'Check your internet connection and ensure you have sufficient balance.' },
                        { q: 'How to reset password?', a: 'Go to Login page, click "Forgot Password" and enter your email.' },
                        {
                            q: '⚠️ Will I be charged if no one picks up or it goes to voicemail?',
                            a: 'YES. Billing starts as soon as the call connects to the network - even if the recipient doesn\'t answer, is busy, or the call goes to voicemail. You are charged for the full call duration from network connection.'
                        },
                        {
                            q: 'How are call minutes charged?',
                            a: 'Calls are billed in 1-minute increments. Any partial minute is rounded up to the next full minute. Example: A 65-second call is charged as 2 minutes.'
                        }
                    ].map((item, i) => (
                        <div key={i} style={{
                            padding: '1rem',
                            background: '#0f172a',
                            borderRadius: '0.75rem',
                            border: item.q.includes('⚠️') ? '1px solid rgba(239, 68, 68, 0.3)' : '1px solid var(--border)',
                            backgroundColor: item.q.includes('⚠️') ? 'rgba(239, 68, 68, 0.05)' : '#0f172a'
                        }}>
                            <p style={{ fontWeight: 600, marginBottom: '0.5rem', color: item.q.includes('⚠️') ? '#ef4444' : 'var(--text-main)' }}>{item.q}</p>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>{item.a}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Blocked Destinations */}
            <div className="card" style={{ marginTop: '1.5rem' }}>
                <h3 style={{ marginBottom: '1rem', color: '#ef4444' }}>🚫 Blocked Numbers & Destinations</h3>
                <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem', fontSize: '0.875rem' }}>
                    For security, compliance, and fraud prevention, the following destinations cannot be called:
                </p>

                {/* Emergency Numbers */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <h4 style={{ fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                        🚨 Emergency Numbers (All Countries)
                    </h4>
                    <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', padding: '0.75rem', background: '#0f172a', borderRadius: '0.5rem' }}>
                        911, 112, 999, 000, 100, 101, 102, 108, 110, 119, 15, 17, 18, 190, 192, 193, and all similar emergency service numbers
                    </p>
                </div>

                {/* Premium Numbers */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <h4 style={{ fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                        💰 Premium & High-Cost Prefixes
                    </h4>
                    <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', padding: '0.75rem', background: '#0f172a', borderRadius: '0.5rem' }}>
                        +1900, +1976 (US Premium) • +4470, +4484, +4487 (UK Premium) • +870, +878, +881-883 (Satellite) • +979 (International Premium) • +800, +808 (Toll-Free)
                    </p>
                </div>

                {/* Blocked Countries */}
                <div>
                    <h4 style={{ fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                        🌍 Restricted Countries & Regions
                    </h4>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', padding: '0.75rem', background: '#0f172a', borderRadius: '0.5rem' }}>
                        <p style={{ marginBottom: '0.5rem' }}><strong>Sanctioned:</strong> North Korea (+850), Iran (+98), Syria (+963), Cuba (+53)</p>
                        <p style={{ marginBottom: '0.5rem' }}><strong>High-Risk:</strong> Afghanistan (+93), Somalia (+252), Yemen (+967), Iraq (+964)</p>
                        <p style={{ marginBottom: '0.5rem' }}><strong>High-Fraud:</strong> Nigeria (+234), Ghana (+233), Kenya (+254), Tanzania (+255)</p>
                        <p style={{ marginBottom: '0' }}><strong>Remote/Expensive:</strong> Norfolk Island (+672), Falklands (+500), Kiribati (+686), Solomon Islands (+677), Cook Islands (+682), Tonga (+676), Samoa (+685), Vanuatu (+678), PNG (+675), Seychelles (+248), Maldives (+960), and other Pacific/Indian Ocean islands</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;
